/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { challengeProgressSchema } from './challenge-progress-schema';

export const getCollectionProgressResponseDataSchema = z.object({
  collectionId: z.number(),
  totalChallenges: z.number(),
  reviewedChallenges: z.number(),
  newChallenges: z.number(),
  passed: z.number(),
  failed: z.number(),
  totalTimeSpent: z.number(),
  totalSessions: z.number(),
  challenges: z.array(challengeProgressSchema),
});

export type IGetCollectionProgressResponseData = z.infer<
  typeof getCollectionProgressResponseDataSchema
>;

export const getCollectionProgressResponseSchema = createApiResponseSchema(
  getCollectionProgressResponseDataSchema,
) as z.ZodSchema<IAPI<IGetCollectionProgressResponseData>>;

export type IGetCollectionProgressResponse = IAPI<IGetCollectionProgressResponseData>;
